import { render, staticRenderFns } from "./summaryShipmentRegular.vue?vue&type=template&id=b4502d64"
import script from "./summaryShipmentRegular.vue?vue&type=script&lang=js"
export * from "./summaryShipmentRegular.vue?vue&type=script&lang=js"
import style0 from "./summaryShipmentRegular.vue?vue&type=style&index=0&id=b4502d64&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports